import { useEffect, useState } from "react";
import { deleteContent } from "../api";
import { Toast } from "src/components";

export const useTableHooks = (data, SortableColumns) => {
    const [tableData, setTableData] = useState([]);
    const [sortColumn, setSortColumn] = useState(null);
    const [sortDirection, setSortDirection] = useState("asc");
    const [selectAllItem, setSelectAllItem] = useState(false);
    const [selectedItem, setSelectedItem] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("category");
    const [selectedSubcategory, setSelectedSubcategory] = useState("subcategory");

    useEffect(() => {
        setTableData(data);
    }, [data]);

    const onSearchContent = (e) => {
        const value = e.target.value;
        if (!value) return setTableData(data);
        setTableData(
            data.filter(item =>
                item?.title?.toLowerCase().includes(value.toLowerCase())
            )
        );
    };

    const onTableCategoryChange = (e) => {
        const value = e.target.value;
        setSelectedCategory(value);
        setSelectedSubcategory("subcategory");
        if (value === "category") return setTableData(data);
        setTableData(data.filter(item => item.category.uuid === e.target.value));
    };

    const onTableSubcategoryChange = (e) => {
        const value = e.target.value;
        setSelectedSubcategory(value);
        if (value === "subcategory") return setTableData(data);
        setTableData(data.filter(item => item.subcategoryUuid === e.target.value));
    };

    const handleSortColumn = (columnIndex) => {
        if (!tableData.length) return;

        const sortableColumn = SortableColumns[columnIndex];

        const columnAccessor = typeof sortableColumn === "function" ?
            sortableColumn :
            typeof sortableColumn === "string" ?
                item => item?.[sortableColumn] ?? "" :
                null;

        if (!columnAccessor) return;

        const newSortDirection = (sortColumn === columnIndex && sortDirection === "asc") ? "desc" : "asc";
        setSortColumn(columnIndex);
        setSortDirection(newSortDirection);

        const sortedData = [...tableData].sort((a, b) => {
            const valueA = columnAccessor(a);
            const valueB = columnAccessor(b);
            const comparison = String(valueA ?? "").localeCompare(String(valueB ?? ""));
            return newSortDirection === "asc" ? comparison : -comparison;
        });

        setTableData(sortedData);
    };

    const handleMainCheckbox = () => {
        const newSelectAll = !selectAllItem;
        setSelectAllItem(newSelectAll);

        if (newSelectAll) {
            setSelectedItem(tableData);
        } else {
            setSelectedItem([]);
        }
    };

    const toggleItemSelection = (item) => {
        setSelectedItem(prev => {
            const isAlreadySelected = prev.some(q => q.uuid === item.uuid);
            if (isAlreadySelected) {
                return prev.filter(q => q.uuid !== item.uuid);
            } else {
                return [...prev, item];
            }
        });
    };

    const isItemSelected = (uuid) =>
        selectedItem.some(u => u.uuid === uuid);

    const handleDeleteSelectedItems = async () => {
        const selectedUUIDs = [...selectedItem.map(user => user.uuid)];

        setSelectedItem([]);
        setSelectAllItem(false);

        for (const uuid of selectedUUIDs) {
            try {
                const response = await deleteContent(uuid);

                if (response.info === "success") {
                    setTableData(prevContent => prevContent.filter(content => content.uuid !== uuid));
                    Toast.success("Content deleted successfully");
                }
            } catch (error) {
                console.error("Error deleting content: ", error);
                Toast.error(error.getApiErrorDetails().message);
            }
        }
    };


    // Added for select all, then deselect specific quotes
    useEffect(() => {
        if (tableData.length === 0) return;
        const allSelected = tableData.length > 0 && tableData.every(q =>
            selectedItem.some(sq => sq.uuid === q.uuid)
        );
        setSelectAllItem(allSelected);
    }, [selectedItem, tableData]);

    return {
        tableData,
        sortColumn,
        sortDirection,
        selectedItem,
        selectAllItem,
        onSearchContent,
        handleMainCheckbox,
        toggleItemSelection,
        isItemSelected,
        setTableData,
        setSortColumn,
        setSortDirection,
        handleSortColumn,
        handleDeleteSelectedItems,
        onTableCategoryChange,
        selectedCategory,
        onTableSubcategoryChange,
        selectedSubcategory
    };
};
